import ArrowRight from '@/assets/svgExports/ArrowRight';
import { GoToCartSection } from '../Common';
import { IS_DESKTOP } from 'src/utils/checkClientDeviceType';

const AddedRequiredBogoProducts = ({
  imageUrl,
  name,
  quantity,
  totalProducts,
  setShowMoreProducts,
}) => {
  const renderMoreItemButton = () => {
    return (
      <>
        {totalProducts > 1 && (
          <button
            onClick={() => setShowMoreProducts(true)}
            className="tw-mt-[8px] tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[10px] tw-border-none tw-px-[8px] tw-py-4 tw-text-[12px]/[16px] "
          >
            {totalProducts - 1} More Items{' '}
            <span className="tw-flex tw-rotate-90 md:tw-rotate-0">
              <ArrowRight height={IS_DESKTOP ? 8 : 10} width={IS_DESKTOP ? 4 : 6} />
            </span>
          </button>
        )}
      </>
    );
  };

  return (
    <div className="tw-flex tw-w-full tw-flex-col tw-justify-between tw-border tw-border-solid tw-border-[#DDDDDD] tw-p-[8px] md:tw-flex-row md:tw-gap-[32px]">
      <div className="tw-flex tw-items-start tw-gap-[6px] md:tw-items-center md:tw-gap-[24px]">
        <img height={IS_DESKTOP ? 82 : 74} width={IS_DESKTOP ? 82 : 74} src={imageUrl} />
        <span className="tw-flex tw-flex-col tw-gap-[4px]">
          <p className="tw-m-0 tw-text-[14px]/[19px] tw-font-semibold md:tw-text-[18px]/[24px]">
            {name}
          </p>
          <p className="tw-m-0 tw-text-[12px]/[16px] md:tw-text-[14px]/[20px]">
            Qty: {quantity}
          </p>
          {IS_DESKTOP && renderMoreItemButton()}
        </span>
      </div>
      {IS_DESKTOP ? <GoToCartSection /> : renderMoreItemButton()}
    </div>
  );
};

export default AddedRequiredBogoProducts;
